import type { CircleRadius } from '../useMapCircleRadius.types';

/**
 * Checks if the circle radius is valid by checking if the center coordinates
 * are valid numbers, and either radiusInMiles is provided and valid, or bounds are provided.
 */
export function checkIfValidCenterRadius(circleRadius: CircleRadius) {
  const { centerLat, centerLng, radiusInMiles, bounds } = circleRadius;

  const hasValidCenter =
    Number.isFinite(centerLat) && Number.isFinite(centerLng);

  if (!hasValidCenter) {
    return false;
  }

  // If radius is provided, it must be valid
  if (radiusInMiles !== undefined) {
    return Number.isFinite(radiusInMiles) && radiusInMiles > 0;
  }

  // If radius is not provided, bounds must be available
  if (bounds) {
    return (
      Number.isFinite(bounds.southwest.lat) &&
      Number.isFinite(bounds.southwest.lng) &&
      Number.isFinite(bounds.northeast.lat) &&
      Number.isFinite(bounds.northeast.lng)
    );
  }

  // Neither radius nor bounds provided
  return false;
}
